'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './zoning_updates.routes';
import JSZip from 'jszip';

export class ZoningUpdatesComponent {
  /*@ngInject*/
  constructor($state, $scope, $rootScope, fetch, lookup, userService, $timeout, baseConfigService, $http, $stateParams) {
    this.$scope = $scope;
    this.fetch = fetch;
    this.$state = $state;
    this.lookup = lookup;
    this.userService = userService;
    this.$timeout = $timeout;
    this.$stateParams = $stateParams;
    this.$http = $http;
    this.baseConfigService = baseConfigService;

    $scope.attachmentData = $scope.attachmentData || {};
    $scope.submissions = [];
    $scope.savemode = null;
    $scope.baseUrl = baseConfigService.getBaseURL();

    $scope.submitmode = null;

    $scope.pendingChanges = false;
    $scope.showPanel = null;

    $scope.togglePanel = function (panelName) {
      $scope.showPanel = panelName;
    };

    $scope.setPending = function () {
      $scope.savemode = 'zoningUpdates';
      $scope.pendingChanges = true;
    }


    // Watch for string entries for dates and convert them
    $scope.$watch('currentZoningForm', function(newVal) {
      if (newVal) {
        // Convert dataset_date_last_updated
        if (newVal.dataset_date_last_updated && typeof newVal.dataset_date_last_updated === 'string') {
          $scope.currentZoningForm.dataset_date_last_updated = new Date(newVal.dataset_date_last_updated);
        }
        
        // Convert map_date_last_updated
        if (newVal.map_date_last_updated && typeof newVal.map_date_last_updated === 'string') {
          $scope.currentZoningForm.map_date_last_updated = new Date(newVal.map_date_last_updated);
        }
      }
    }, true);

    
    $scope.addToSubmissions = function (submission) {
      const index = $scope.submissions.indexOf(submission);
      if (index > -1) { // only splice array when item is found
        $scope.submissions.splice(index, 1); // 2nd parameter means remove one item only
      } else {
        $scope.submissions.push(submission);
      }

      if ($scope.submissions.length > 0) {
        $scope.submitmode = 'zoningUpdates';
      } else {
        $scope.submitmode = null;
      }
    }

    $scope.getStationbyID = function (station) {
     
      if (station) {
        $scope.currentSelectedStationId = station;
        lookup.setCurrentStation(station);
      }
      fetch.getItem(`api/data/submissions/${$scope.currentJurisdiction}`, 'Zoning')
        .then(response => {

          console.log(response.data)
          $scope.zoningUpdates = _.filter(response.data, { submission_policy_name: 'Jurisdiction Zoning Updates' });
          if ($scope.zoningUpdates.length > 0) {
            $scope.zoningUpdates.forEach(element => {
              if (element.submitted == true) {
                $scope.zoningUpdatesCheck = true;
              }
            });
          }
          if ($scope.zoningUpdates.length > 0) {
            $scope.rec_id = $scope.zoningUpdates[0].rec_id; // Assuming rec_id is in the first element
            $scope.getCurrentZoningForm($scope.rec_id);
          }
        })
        .catch(err => {
          console.log(err);
          if(err.status === 403){
            $state.go('login');
          }
        })
    }



    /**
* Update station area dropdown based on jurisdiction selected
* @param {*} jurisdiction 
*/
$scope.getStationAreaList = function (jurisdiction) {
  lookup.setJurisdiction(jurisdiction);
  fetch.getAllItems(`api/data/stationareas/${jurisdiction}`)
    .then(response => {
      
      $scope.stationAreas = response.data;
      if (lookup.getCurrentStation()) {
        $scope.currentSelectedStationId = lookup.getCurrentStation();
        $scope.getStationbyID($scope.currentSelectedStationId)
      }
    })
    .catch(err => {
      console.log(err);
      if(err.status === 403){
        $state.go('login');
      }
    })
}

    $scope.getCurrentZoningForm = function (rec_id) {
     if (rec_id) {
      $scope.rec_id = rec_id;
     }

      fetch.getAllItems(`api/data/getZoningForm/${$scope.currentJurisdiction}`)
        .then(response => {
          
          $scope.currentZoningForm = response.data[0];
          // Call updateDatasetTypes to populate comma-separated string
          if ($scope.currentZoningForm && $scope.currentZoningForm.dataset_types) {
                $scope.updateDatasetTypes();
            }
      })
        .catch(err => {
          console.log(err);
          if(err.status === 403){
            $state.go('login');
          }
        })

    }

    

    // Update the comma-separated string
    $scope.updateDatasetTypes = function() {
    var selected = [];
    if ($scope.currentZoningForm.dataset_types.general_plan) {
        selected.push('General Plan');
    }
    if ($scope.currentZoningForm.dataset_types.specific_plan) {
        selected.push('Specific Plan');
    }
    if ($scope.currentZoningForm.dataset_types.zoning) {
        selected.push('Zoning');
    }
    if ($scope.currentZoningForm.dataset_types.other) {
        selected.push('Other');
    }
    $scope.currentZoningForm.dataset_type = selected.join(', ');
    console.log('updateDatasetTypes called', $scope.currentZoningForm.dataset_type)
    $scope.setPending();
};


    // Validation 
    $scope.hasSelectedDatasetType = function() {
      if (!$scope.currentZoningForm || !$scope.currentZoningForm.dataset_types) {
        return false;
      }
        return $scope.currentZoningForm.dataset_types.general_plan || 
              $scope.currentZoningForm.dataset_types.specific_plan || 
              $scope.currentZoningForm.dataset_types.zoning ||
              $scope.currentZoningForm.dataset_types.other;
    };

    // Checks if "Other" is selected or at least two options are selected
    $scope.hasOtherPlusOtherOptions = function() {
    if (!$scope.currentZoningForm || !$scope.currentZoningForm.dataset_types) {
        return false;
    }
    var types = $scope.currentZoningForm.dataset_types;
    var nonOtherCount = 0;
    
    if (types.general_plan) nonOtherCount++;
    if (types.specific_plan) nonOtherCount++;
    if (types.zoning) nonOtherCount++;
    
    return types.other && nonOtherCount >= 1;
};


// Checks if "Other" is NOT selected but at least two options are selected
$scope.hasMultipleNonOtherOptions = function() {
    if (!$scope.currentZoningForm || !$scope.currentZoningForm.dataset_types) {
        return false;
    }
    var types = $scope.currentZoningForm.dataset_types;
    var nonOtherCount = 0;
    
    if (types.general_plan) nonOtherCount++;
    if (types.specific_plan) nonOtherCount++;
    if (types.zoning) nonOtherCount++;
    
    return !types.other && nonOtherCount >= 2;
};

$scope.hasOtherOrSingleOption = function() {
    if (!$scope.currentZoningForm || !$scope.currentZoningForm.dataset_types) {
        return false;
    }
    var types = $scope.currentZoningForm.dataset_types;
    var totalCount = 0;
    
    if (types.general_plan) totalCount++;
    if (types.specific_plan) totalCount++;
    if (types.zoning) totalCount++;
    if (types.other) totalCount++;
    
    return types.other || totalCount === 1;
};

// Combine dates and update the condition for map_date_last_updated
$scope.updateMapDates = function() {
    var dates = [];
    if ($scope.currentZoningForm.map_date_general_plan) dates.push($scope.currentZoningForm.map_date_general_plan);
    if ($scope.currentZoningForm.map_date_specific_plan) dates.push($scope.currentZoningForm.map_date_specific_plan);
    if ($scope.currentZoningForm.map_date_zoning) dates.push($scope.currentZoningForm.map_date_zoning);
    if ($scope.currentZoningForm.map_date_other) dates.push($scope.currentZoningForm.map_date_other);

    $scope.currentZoningForm.map_date_last_updated = dates.join(', ');
    $scope.setPending();
};

// Combine dates and update the condition for dataset_date_last_updated
$scope.updateDatasetDates = function() {
    var dates = [];
    if ($scope.currentZoningForm.dataset_date_general_plan) dates.push($scope.currentZoningForm.dataset_date_general_plan);
    if ($scope.currentZoningForm.dataset_date_specific_plan) dates.push($scope.currentZoningForm.dataset_date_specific_plan);
    if ($scope.currentZoningForm.dataset_date_zoning) dates.push($scope.currentZoningForm.dataset_date_zoning);
    
    $scope.currentZoningForm.dataset_date_last_updated = dates.join(', ');
    $scope.setPending();
};

// Combine urls and update the condition for dataset_url
$scope.updateDatasetUrls = function() {
    var dates = [];
    if ($scope.currentZoningForm.dataset_url_general_plan) dates.push($scope.currentZoningForm.dataset_url_general_plan);
    if ($scope.currentZoningForm.dataset_url_specific_plan) dates.push($scope.currentZoningForm.dataset_url_specific_plan);
    if ($scope.currentZoningForm.dataset_url_zoning) dates.push($scope.currentZoningForm.dataset_url_zoning);
    if ($scope.currentZoningForm.dataset_url_other) dates.push($scope.currentZoningForm.dataset_url_other);
    
    $scope.currentZoningForm.dataset_url = dates.join(', ');
    $scope.setPending();
};




    $scope.updateZoningForm = function () {
      console.log("Form Data Before Sending:", $scope.currentZoningForm);

      $scope.formSubmitted = true;
      if (zoningForm.$invalid) {
        $scope.saving = false;
        return;
      }

      // // Ensure cleared fields send `null` instead of empty strings or undefined values
      Object.keys($scope.currentZoningForm).forEach(key => {
        if ($scope.currentZoningForm[key] === "" || $scope.currentZoningForm[key] === undefined) {
          $scope.currentZoningForm[key] = null;
        }
      });
 
      console.log("Payload being sent:", $scope.currentZoningForm);
  fetch.updateItem(`api/data/zoning-updates/forms/update`, $scope.currentZoningForm)
      .then(response => {
        $scope.saved = true;
        $scope.saving = false;
        $scope.pendingChanges = false;
        setTimeout(() => {
          $scope.savemode = null;
          $scope.saved = false;
          $scope.$apply();
        }, 4000);
      })
      .catch(err => {
        console.log(err);
        if(err.status === 403){
          $state.go('login');
        }
      })
    }

    $scope.submitZoningUpdates = function () {
      $scope.formSubmitted = true;
      $scope.saving = true;
      var upsertData = []; // Initialize upsertData array

      $scope.upsertData = []; // Reset or initialize upsert data array


      if ($scope.zoningUpdatesCheck && $scope.zoningUpdates.length > 0) {
        $scope.zoningUpdates.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              zoning_submissions_form: true,
              submitted: true,
            })
          }
        });
      }
      fetch.updateItem('api/data/submissions/update', upsertData)
        .then(response => {
          
          $scope.saving = false;
          $scope.submissions = [];
          $scope.saved = true;
          $scope.pendingChanges = false;
          setTimeout(() => {
            $scope.submitmode = null;
            $scope.saved = false;
            $scope.$apply();
          }, 2000);
        })
        .catch(err => {
          console.log(err);
          if(err.status === 403){
            $state.go('login');
          }
        })
    }
      
 // File upload functions 

// $scope.initializeField = function (fieldId) {
//   if (!$scope.attachmentData[fieldId]) {
//     $scope.attachmentData[fieldId] = {
//       fileName: null,
//       file: null,
//       isFileSelected: false
//     };
//   }
// };

// Function to open the file dialog
// $scope.openFileDialog = function (fieldId) {
//   console.log(fieldId)
//   $timeout(function () {
//     document.getElementById('fileInput' + fieldId).click();
//   }, 0);
// };

// Function to handle file changes
// $scope.fileChanged = function (fieldId, element) {
//   console.log(fieldId);
//   console.log(element);
//   $scope.initializeField(fieldId);  // Ensure field is initialized

//   var file = element.files[0];
//   if (file) {
//     // Check if the file type is PDF, Word document, or Excel file
//     if (
//       file.type !== 'application/pdf' &&
//       file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && // For .docx
//       file.type !== 'application/msword' && // For .doc
//       file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && // For .xlsx
//       file.type !== 'application/vnd.ms-excel' // For .xls
//     ) {
//       alert('Please select a PDF, Word document, or Excel file.');
//       element.value = ''; // Reset input to clear the wrong file type
//       return;
//     }

//     $scope.attachmentData[fieldId].fileName = file.name;
//     $scope.attachmentData[fieldId].file = file;
//     $scope.attachmentData[fieldId].isFileSelected = true;

//     $scope.$apply();
//   }
// };
$scope.selectedFile = null;

$scope.handleFileSelect = function(element) {
  console.log(element);
  $scope.setPending();
  $scope.$apply(function() {
    // Store all files instead of just the first one
    $scope.selectedFiles = Array.from(element.files);
    $scope.selectedFile = element.files[0]; // Keep for backward compatibility
  });
};


$scope.uploadFile = function(ngmodelfile) {
  var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
  console.log(ngmodel);
  
  // Check if we have files from folder selection
  if (!$scope.selectedFiles || $scope.selectedFiles.length === 0) {
    console.error('No files selected');
    return;
  }

  $scope[`fileUploading_${ngmodelfile}`] = true;
  
  // Create a zip file from the folder contents
  const zip = new JSZip();
  
  // Add all files to the zip
  const promises = $scope.selectedFiles.map(file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = function(e) {
        // Preserve folder structure by using relative path if available
        const relativePath = file.webkitRelativePath || file.name;
        zip.file(relativePath, e.target.result);
        resolve();
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  });
  
  // When all files are added to zip, generate and upload
  Promise.all(promises)
    .then(() => zip.generateAsync({type: 'blob'}))
    .then(zipBlob => {
      // Create a File object from the zip blob with jurisdiction name
      const jurisdictionName = $scope.currentJurisdiction ? $scope.currentJurisdiction.replace(/\s+/g, '_') : 'jurisdiction';
      const zipFileName = `${jurisdictionName}_${ngmodel}.zip`;
      
      const zipFile = new File([zipBlob], zipFileName, {type: 'application/zip'});
      
      const fileUpload = {
        fileName: zipFile.name,
        fileType: zipFile.type
      };
      
      return fetch.updateItem('api/data/get-signed-url', fileUpload)
        .then(response => {
          console.log('Signed URL:', response.data.signedUrl);
          console.log('Public URL:', response.data.publicUrl);
          
          return $http({
            method: 'PUT',
            url: response.data.signedUrl,
            data: zipFile,
            headers: {
              'Content-Type': zipFile.type,
            }
          })
          .then(() => {
            $scope.currentZoningForm[ngmodel] = response.data.publicUrl;
            return response.data.publicUrl;
          });
        });
    })
    .then(publicUrl => {
      console.log('Upload successful');
      console.log('Public URL:', publicUrl);
      
      $scope[`fileUploading_${ngmodelfile}`] = false;
      $scope[`${ngmodelfile}`] = '';
      $scope.clearFile(ngmodelfile);
      $scope.uploadSuccess = true;
      $scope.selectedFiles = null;
      $scope.selectedFile = null;
    })
    .catch(error => {
      console.error('Error:', error);
      alert('Upload failed');
      $scope[`fileUploading_${ngmodelfile}`] = false;
    });
};


$scope.clearFile = function(ngmodelfile) {
  const fileInput = document.getElementById(ngmodelfile);
  if (fileInput) {
    fileInput.value = '';
    $scope.selectedFiles = null;
    $scope.selectedFile = null;
  }
};

$scope.checkSubstring = function (input) {
return input && input.length >= 4 && input.substring(0, 4) === 'http';
};

$scope.removeFile = function(ngmodel) {
console.log(ngmodel);
  $scope.currentZoningForm[ngmodel] = '';
  $scope.setPending();
  $scope.savemode = 'zoningUpdates';
  $scope.pendingChanges = true;
};


// End file upload functions 

}

$onInit() {
  this.userService.getCurrentUser()
    .then(response => {
      
      this.$scope.currentUser = response.data;
      this.userService.setCurrentUser(response.data);
      this.$scope.currentZoningForm = {};
      this.$scope.currentZoningForm.dataset_types = {
        general_plan: false,
        specific_plan: false,
        zoning: false,
        other: false
      };
      return this.getJurisdictionList();
    })
    .catch(err => {
      console.log(err);
      if(err.status === 403){
        this.$state.go('login');
      }
    })
}

getJurisdictionList() {
  this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list')
  .then(response => {
      this.$scope.loading = false;
      this.$scope.jurisdictions = response.data;

      // Check if user role is Administrator
      if (this.$scope.currentUser.role === 'Administrator') {
        console.log("admin");
        // Check for the jurisdiction parameter in the URL
        const jurisdictionParam = this.$stateParams.jurisdiction;
        console.log(this.$stateParams);
        if (jurisdictionParam) {
          this.$scope.currentJurisdiction = jurisdictionParam;
        } else if (this.lookup.getJurisdiction()) {
          this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
        } else {
          // If no parameter, default to the first jurisdiction
          this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
        }
      } else {
         if (this.lookup.getJurisdiction()) {
          this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
        } else {
          // If no parameter, default to the first jurisdiction
          this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
        }
      }
      console.log(this.$scope.currentJurisdiction);
      this.lookup.setJurisdiction(this.$scope.currentJurisdiction);
      this.$scope.getStationAreaList(this.$scope.currentJurisdiction);
  })
  .catch(err => {
      console.log(err);
  });
}
}

export default angular.module('websiteApp.zoning_updates', [uiRouter])
  .config(routes)
  .component('zoningUpdates', {
    template: require('./zoning_updates.html'),
    controller: ZoningUpdatesComponent,
    controllerAs: 'zoningUpdatesCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/zoning_updates/zoning_updates.component.js